import { genres } from "@/mocks/comics";

export default function GenreGrid() {
  return (
    <section id="genres" className="scroll-mt-28 bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1180px] px-4 md:px-6">
        <div className="max-w-[660px]">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900">
            <i className="ri-apps-2-line text-sm" aria-hidden="true"></i>
            题材分类
          </span>
          <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-3xl">按题材找对你的那一部</h2>
          <p className="mt-2 text-sm leading-relaxed text-foreground-600">
            题材标签是本站组织内容的主要方式。每个分类下的数量是当前已整理的作品数，点击后会带着题材回到上方
            的作品库继续筛选。
          </p>
        </div>

        <div className="mt-7 grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-4">
          {genres.map((genre) => (
            <a
              key={genre.name}
              href="#latest"
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-secondary-400"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-100 text-secondary-700 transition-colors group-hover:bg-secondary-500 group-hover:text-background-50">
                  <i className={`${genre.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <span className="font-heading text-lg text-foreground-300 transition-colors group-hover:text-primary-500">
                  {genre.count}
                </span>
              </div>
              <h3 className="mt-3 font-heading text-base text-foreground-950">{genre.name}</h3>
              <p className="mt-1 text-xs leading-relaxed text-foreground-500">{genre.desc}</p>
              <span className="mt-3 inline-flex items-center gap-1 text-xs text-secondary-700 opacity-0 transition-opacity group-hover:opacity-100">
                去看这个题材
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}